import backHome from 'src/views/backEndStage/page-endhome.vue'
import setPage from 'src/views/backEndStage/other/setPage.vue'
import blank from 'src/views/backEndStage/other/blank.vue'
import test from 'src/views/backEndStage/other/test.vue'

// ***setting****
import currency from 'src/views/backEndStage/setting/page-currency.vue'
import currencyAdd from 'src/views/backEndStage/setting/page-currencyAdd.vue'
import taskSetting from 'src/views/backEndStage/setting/page-taskSetting.vue'
import taskTypeAdd from 'src/views/backEndStage/setting/page-taskType-add.vue'
import holiday from 'src/views/backEndStage/setting/page-holiday.vue'
import post from 'src/views/backEndStage/setting/page-post.vue'
import ticket from 'src/views/backEndStage/setting/page-ticket.vue'
import ticketAdd from 'src/views/backEndStage/setting/page-ticket-add.vue'
import bonusLevel from 'src/views/backEndStage/setting/page-bonus&level.vue'

// import bonusCycle from 'src/views/backEndStage/setting/bonus-cycle.vue'
// import rankCycle from 'src/views/backEndStage/setting/rank-cycle.vue'
// import budget from 'src/views/backEndStage/setting/budget.vue'
// import taskTime from 'src/views/backEndStage/setting/taskTime.vue'
import backLog from 'src/views/backEndStage/setting/log.vue'

//***task***
import taskSkim from 'src/views/backEndStage/task/page-task-skim.vue'

//***document***
import skim from 'src/views/backEndStage/document/page-skim.vue'
import tpl from 'src/views/backEndStage/document/page-tpl.vue'

// ****finance****
import budgetRecharge from 'src/views/backEndStage/finance/page-budget-recharge.vue'
import budgetRechargeAdd from 'src/views/backEndStage/finance/page-budget-recharge-add.vue'
import budgetSet from 'src/views/backEndStage/finance/page-budget-set.vue'
import bonusRecharge from 'src/views/backEndStage/finance/page-bonus-recharge.vue'
import bonusRechargeAdd from 'src/views/backEndStage/finance/page-bonus-recharge-add.vue'
import rankRecharge from 'src/views/backEndStage/finance/page-rank-recharge.vue'
import rankRechargeAdd from 'src/views/backEndStage/finance/page-rank-recharge-add.vue'
// import addRank from 'src/views/backEndStage/person/page-add-rank.vue'
import settleList from 'src/views/backEndStage/finance/page-settle-list.vue'
import note from 'src/views/backEndStage/finance/page-note.vue'

// import settleDetail from 'src/views/backEndStage/finance/settle-detail.vue'

// *****person***
import role from 'src/views/backEndStage/person/page-role.vue'
import Bulist from 'src/views/backEndStage/person/page-bu-list.vue'
import addBu from 'src/views/backEndStage/person/page-add-bu.vue'
import addPeople from 'src/views/backEndStage/person/page-add-people.vue'
import buDetail from 'src/views/backEndStage/person/page-bu-detail.vue'
// import personInfo from 'src/views/backEndStage/person/page-person-info.vue'




export default {
    path: '/backstage',
    component: backHome,
    name: 'backhome',
    meta:{code:2000},
    // isBackStage: true,
    children:[
        {
            path:"task",
            name:"back-task",
            icon:"back-task.png",
            text:"任务管理",
            component:blank,
            meta:{code:2500},
            children:[
                {
                    path:"manager",
                    name:"back-task-manager",
                    text:"任务浏览",
                    component:taskSkim,
                    meta:{code:2510},
                    secondMenu:true,
                },
                // {
                //     path:"review",
                //     name:"back-task-review",
                //     text:"任务审核",
                //     component:test,
                //     secondMenu:true,
                // },
                // {
                //     path:"condition",
                //     name:"back-task-condition",
                //     text:"审核条件",
                //     component:test,
                //     secondMenu:true,
                // },
                // {
                //     path:"complaint",
                //     name:"back-task-complaint",
                //     text:"任务投诉",
                //     component:test,
                //     secondMenu:true,
                // },
            ]
        },
        {
            path:"doc",
            name:"back-document",
            icon:"back-doc.png",
            text:"文档管理",
            component:blank,
            meta:{code:2400},
            children:[
                {
                    path:"skim",
                    name:"back-doc-skim",
                    text:"文件浏览",
                    component:skim,
                    meta:{code:2410},
                    secondMenu:true,
                },
                {
                    path:"template",
                    name:"back-doc-template",
                    text:"文档模板",
                    component:tpl,
                    meta:{code:2420},   
                    secondMenu:true,
                },
            ]
        },
        {
            path:"finance",
            name:"back-finance",
            icon:"back-finance.png",
            text:"资产管理",
            component:blank,
            meta:{code:2300},
            children:[
                {
                    path:"budget",
                    name:"back-finance-budget",
                    text:"预算充值",
                    component:budgetRecharge,
                    meta:{code:2310},
                    secondMenu:true,
                },
                {
                    path:"budget/:id",
                    name:"back-finance-budget-add",
                    text:"充值",
                    component:budgetRechargeAdd,
                    meta:{code:2310},
                },
                {
                    path:"budget/set/:id",
                    name:"back-finance-budget-set",
                    text:"预算设置",
                    component:budgetSet,
                    meta:{code:2310},
                },
                {
                    path:"assets",
                    name:"back-finance-assets",
                    text:"奖金充值",
                    component:bonusRecharge,
                    meta:{code:2320},
                    secondMenu:true,
                },
                {
                    path:"assets/:id",
                    name:"back-finance-assets-add",
                    text:"充值",
                    component:bonusRechargeAdd,
                    meta:{code:2320},
                },
                {
                    path:"rank",
                    name:"back-finance-rank",
                    text:"职级充值",
                    component:rankRecharge,
                    meta:{code:2350},
                    secondMenu:true,
                },
                {
                    path:"rank/:id",
                    name:"back-finance-rank-add",
                    text:"充值",
                    component:rankRechargeAdd,
                    meta:{code:2350},
                },


                {
                    path:"settle-log",
                    name:"back-finance-settle",
                    text:"结算记录",
                    component:settleList,
                    meta:{code:2330},
                    secondMenu:true,
                },
                // {
                //     path:"settle-detail",
                //     name:"back-finance-settleDetail",
                //     text:"记录详情",
                //     component:settleDetail,
                // },


                {
                    path:"note",
                    name:"back-finance-note",
                    text:"充值记录",
                    component:note,
                    secondMenu:true,
                    meta:{code:2340},
                },
                // {
                //     path:"budget-apply",
                //     name:"back-finance-budgetApply",
                //     text:"预算申请",
                //     component:test,
                //     secondMenu:true,
                // },
                // {
                //     path:"rate",
                //     name:"back-finance-rate",
                //     text:"汇率设置",
                //     component:test,
                //     secondMenu:true,
                // },
            ]
        },
        {
            path:"person",
            name:"back-person",
            icon:"back-person.png",
            text:"职员管理",
            component:blank,
            meta:{code:2200},
            children:[
                {
                    path:"bu",
                    name:"back-person-assign",
                    text:"BU与职员",
                    component:Bulist,
                    meta:{code:2210},
                    secondMenu:true,
                },

                {
                    path:"role",
                    name:"back-person-role",
                    text:"角色设置",
                    component:role,
                    meta:{code:2220},
                    secondMenu:true,
                },
                // {
                //     path:"role/setting",
                //     name:"back-person-role-setting",
                //     text:"权限设置",
                //     component:test,
                // },
                {
                    path:"bu/add-person",
                    name:"back-person-bu-addPerson",
                    text:"添加职员",
                    component:addPeople,
                    meta:{code:2210},
                },
                {
                    path:"bu/new-bu",
                    name:"back-person-create-bu",
                    text:"新建BU",
                    component:addBu,
                    meta:{code:2210},
                },
                {
                    path:"bu/:buId",
                    name:"back-person-bu-detail",
                    text:"BU详情",
                    component:buDetail,
                    meta:{code:2210},
                },
                // {
                //     path:"person/:userId",
                //     name:"back-person-person-detail",
                //     text:"职员详情",
                //     component:personInfo,
                //     meta:{code:2210},
                // },

            ]
        },
        {
            path:"base-setting",
            name:"back-base-setting",
            icon:"back-setting.png",
            text:"基础设置",
            component:blank,
            meta:{code:2100},
            children:[
                {
                    path:"currency",
                    name:"back-setting-currency",
                    text:"虚拟币设置",
                    component:currency,
                    meta:{code:2110},
                    secondMenu:true,
                },
                {
                    path:"currency/:id",
                    name:"back-setting-addcurrency",
                    text:"创建虚拟币",
                    component:currencyAdd,
                    meta:{code:2110},
                    // secondMenu:true,
                },
                {
                    path:"taskType",
                    name:"back-setting-taskType",
                    text:"任务设置",
                    component:taskSetting,
                    meta:{code:2120},
                    secondMenu:true,
                },
                {
                    path:"taskType/:id",
                    name:"back-setting-addTaskType",
                    text:"任务类型详情",
                    component:taskTypeAdd,
                    meta:{code:2120},
                    // secondMenu:true,
                },
                {
                    path:"time",
                    name:"back-setting-time",
                    text:"非工作日设置",
                    component:holiday,
                    meta:{code:2130},
                    secondMenu:true,
                },
                {
                    path:"ticket",
                    name:"back-setting-ticket",
                    text:"罚单设置",
                    component:ticket,
                    meta:{code:2140},
                    secondMenu:true,
                },
                {
                    path:"ticket/:id",
                    name:"back-setting-addTicket",
                    text:"罚单详情",
                    component:ticketAdd,
                    meta:{code:2140},
                    // secondMenu:true,
                },
                // {
                //     path:"bonus",
                //     name:"back-setting-bonus",
                //     text:"奖金周期",
                //     component:bonusCycle,
                //     secondMenu:true,
                // },
                // {
                //     path:"budget",
                //     name:"back-setting-budget",
                //     text:"预算设置",
                //     component:budget,
                //     secondMenu:true,
                // },
                // {
                //     path:"taskTime",
                //     name:"back-setting-taskTime",
                //     text:"任务时间",
                //     component:taskTime,
                //     secondMenu:true,
                // },
                // {
                //     path:"level",
                //     name:"back-setting-level",
                //     text:"职级周期",
                //     component:rankCycle,
                //     secondMenu:true,
                // },
                {
                    path:"post",
                    name:"back-setting-post",
                    text:"岗位设置",
                    component:post,
                    meta:{code:2150},
                    secondMenu:true,
                },
                {
                    path:"bonus&level",
                    name:"back-setting-bonus&level",
                    text:"奖金与职级",
                    component:bonusLevel,
                    meta:{code:2160},
                    secondMenu:true,
                },
                // {
                //     path:"log",
                //     name:"back-setting-log",
                //     text:"操作日志",
                //     component:backLog,
                //     meta:{code:2170},
                //     secondMenu:true,
                // },

            ]
        },
    ]

}



// WEBPACK FOOTER //
// ./src/config/router-back-config.js